import styled from 'styled-components';
import { getSpacing, Spacing } from '../../../utils';

export const StyledWrapper = styled.div<{ isSticky?: boolean; zIndex?: Spacing }>`
  position: ${({ isSticky }) => (isSticky ? 'sticky' : 'absolute')};
  top: 0;
  left: 0;
  right: 0;
  z-index: ${({ zIndex, theme: { spacing, zIndex: muiZIndex } }) =>
    zIndex ? getSpacing(zIndex, spacing) : muiZIndex.modal};
`;
